import { render } from "./UserProfileCard.vue?vue&type=template&id=af1b59fc&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"

import "./UserProfileCard.vue?vue&type=style&index=0&id=af1b59fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1b59fc"]])

export default __exports__